'use client';

import { PropsWithChildren } from 'react';

import { useAuthToken } from '@/store/auth';

import { OddsServiceBeforeProvider } from './components/odds-service-before-provider';
import { OddsServiceAccountProvider } from './components/odds-service-account-provider';

export function OddsServiceProvider({ children }: PropsWithChildren) {
	const authToken = useAuthToken();

	return (
		<>
			{authToken ? <OddsServiceAccountProvider /> : <OddsServiceBeforeProvider />}

			{children}
		</>
	);
}